import React from "react";
import { Link } from "react-router";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer
        className="footer-section bg_img"
        style={
          {
            // background: `url(${process.env.PUBLIC_URL}/images/footer/bg.jpg) center`,
          }
        }
      >
        <div className="footer-top">
          <div className="container">
            <div className="footer-wrapper d-flex flex-wrap align-items-center justify-content-md-between justify-content-center">
              <div className="logo mb-3 mb-md-0">
                <Link to="/">
                  <img src="/images/logo.png" alt="logo" className="w-20" />
                </Link>
              </div>
              <ul className="footer-links d-flex flex-wrap justify-content-center">
                <li>
                  <a href="https://blog.dannysgameroom.com">Blog</a>
                </li>
                <li>
                  <Link to="/terms&conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="footer-wrapper d-flex flex-wrap justify-content-center align-items-center text-center">
              <p className="copyright text-white">
                Copyright &copy; {currentYear} All Rights Reserved by
                <Link to="/" className=" text--base ms-2" target="_blank">
                  Dannysgameroom.com
                </Link>
              </p>
            </div>
          </div>
        </div>
        {/* <div className="shapes">
                    <img src="/images/footer/shape.png" alt="footer" className="shape1"/>
                </div> */}
      </footer>
    </>
  );
};
export default Footer;
